// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * core-service
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1-35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiErrorAPIModel,
    ApiErrorAPIModelFromJSON,
    ApiErrorAPIModelToJSON,
    LimitSummaryAPIModel,
    LimitSummaryAPIModelFromJSON,
    LimitSummaryAPIModelToJSON,
} from '../models';

/**
 * DepositApi - interface
 * 
 * @export
 * @interface DepositApiInterface
 */
export interface DepositApiInterface {
    /**
     * Get limits for account deposit via sbp
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DepositApiInterface
     */
    getSBPLimitsRaw(): Promise<runtime.ApiResponse<LimitSummaryAPIModel>>;

    /**
     * Get limits for account deposit via sbp
     */
    getSBPLimits(): Promise<LimitSummaryAPIModel>;

}

/**
 * 
 */
export class DepositApi extends runtime.BaseAPI implements DepositApiInterface {

    /**
     * Get limits for account deposit via sbp
     */
    async getSBPLimitsRaw(): Promise<runtime.ApiResponse<LimitSummaryAPIModel>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = typeof token === 'function' ? token("httpAuth", []) : token;

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/deposits/sbp/limits`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => LimitSummaryAPIModelFromJSON(jsonValue));
    }

    /**
     * Get limits for account deposit via sbp
     */
    async getSBPLimits(): Promise<LimitSummaryAPIModel> {
        const response = await this.getSBPLimitsRaw();
        return await response.value();
    }

}
